import React from 'react';

export const NewStatCard = ({ title, value, icon, colorTheme = 'slate' }) => {
  // Theme definitions for the icon background
  const themeStyles = {
    slate: 'bg-slate-50 border-slate-200 text-slate-700',
    amber: 'bg-amber-50 border-amber-200 text-amber-600',
    red: 'bg-red-50 border-red-200 text-red-600',
    emerald: 'bg-emerald-50 border-emerald-200 text-emerald-600',
  };

  const bgStyle = themeStyles[colorTheme] || themeStyles.slate;

  return (
    <div className="bg-white border border-slate-200 p-5 shadow-xs flex items-center gap-4">
      <div className={`w-11 h-11 border flex items-center justify-center shrink-0 ${bgStyle}`}>
        {icon}
      </div>
      <div>
        <div className="text-2xl font-bold text-slate-900 tracking-tight">{value}</div>
        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{title}</div>
      </div>
    </div>
  );
};
